// Currency utility functions
export const formatCurrency = (amount, currency = 'KES') => {
  if (amount === null || amount === undefined) return '';
  
  const numAmount = typeof amount === 'string' ? parseFloat(amount) : amount;
  
  if (isNaN(numAmount)) return '';
  
  switch (currency) {
    case 'KES':
      return `KES ${numAmount.toLocaleString('en-KE', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      })}`;
    case 'USD':
      return `$${numAmount.toLocaleString('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      })}`;
    case 'EUR':
      return `€${numAmount.toLocaleString('en-EU', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      })}`;
    case 'GBP':
      return `£${numAmount.toLocaleString('en-GB', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      })}`;
    case 'CAD':
      return `C$${numAmount.toLocaleString('en-CA', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      })}`;
    default:
      return `${currency} ${numAmount.toLocaleString()}`;
  }
};

export const getCurrencySymbol = (currency = 'KES') => {
  switch (currency) {
    case 'KES':
      return 'KES';
    case 'USD':
      return '$';
    case 'EUR':
      return '€';
    case 'GBP':
      return '£';
    case 'CAD':
      return 'C$';
    default:
      return currency;
  }
};

export const parseCurrency = (value) => {
  if (typeof value === 'number') return value;
  if (typeof value === 'string') {
    // Remove currency symbols and commas, then parse
    const cleaned = value.replace(/[^\d.-]/g, '');
    return parseFloat(cleaned) || 0;
  }
  return 0;
};
